import { IconSquare } from '@monthio/design-system'
import {
	AllotmentHut,
	RentalProperty as Apartment,
	AutoCamper,
	Boat,
	BuildingPlot,
	Campingwagon,
	Car,
	Farm,
	OwnedHome as House,
	HouseBoat,
	Motorcycle,
	Summerhouse,
} from '@monthio/icons'
import React from 'react'

import { AssetType } from '../AssetOverview.types'

interface AssetLogoProps {
	assetType: AssetType
}

export const AssetLogo: React.FC<AssetLogoProps> = ({ assetType }) => {
	switch (assetType) {
		case AssetType.House:
			return (
				<IconSquare icon={House} backgroundColor="#E7F3FE" color="#0A70C2" />
			)
		case AssetType.Apartment:
			return (
				<IconSquare
					icon={Apartment}
					backgroundColor="#F7F7FD"
					color="#565CD4"
				/>
			)
		case AssetType.VacationHome:
			return (
				<IconSquare
					icon={Summerhouse}
					backgroundColor="#E7F3FE"
					color="#2589A7"
				/>
			)
		case AssetType.AllotmentGardenHouse:
			return (
				<IconSquare
					icon={AllotmentHut}
					backgroundColor="#E7F3FE"
					color="#2589A7"
				/>
			)
		case AssetType.Houseboat:
			return (
				<IconSquare
					icon={HouseBoat}
					backgroundColor="#E7F3FE"
					color="#0A70C2"
				/>
			)
		case AssetType.Farmhouse:
			return (
				<IconSquare icon={Farm} backgroundColor="#E7F3FE" color="#0A70C2" />
			)
		case AssetType.BuildingPlot:
			return (
				<IconSquare
					icon={BuildingPlot}
					backgroundColor="#E7F3FE"
					color="#0A70C2"
				/>
			)
		case AssetType.Car:
			return <IconSquare icon={Car} backgroundColor="#F7F7FD" color="#565CD4" />
		case AssetType.Motorcycle:
			return (
				<IconSquare
					icon={Motorcycle}
					backgroundColor="#F7EBF9"
					color="#B74DC9"
				/>
			)
		case AssetType.CampingWagon:
			return (
				<IconSquare
					icon={Campingwagon}
					backgroundColor="#FEEEE7"
					color="#F46325"
				/>
			)
		case AssetType.Boat:
			return (
				<IconSquare icon={Boat} backgroundColor="#FDE7EF" color="#EE2B6D" />
			)
		case AssetType.RV:
			return (
				<IconSquare
					icon={AutoCamper}
					backgroundColor="#FEEEE7"
					color="#F46325"
				/>
			)
	}
}
